/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {generateStructuredOutput} from '../api'

export const useMutationGenerateStructuredOutput = createReactQueryMutationHook('generateStructuredOutput', generateStructuredOutput)
